import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import {
  PrivateRoute,
  AdminRoute,
  ApprovedRoute
} from "./components/ProtectedRoutes";

// Public pages
import LandingPage from "./pages/LandingPage";
import LegalPage from "./pages/LegalPage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import BlogListPublic from "./pages/blog/BlogListPublic";
import BlogDetailPage from "./pages/blog/BlogDetailPage";
import NotFoundPage from "./pages/NotFoundPage";

// User pages
import ProfilePage from "./pages/ProfilePage";
import PaymentPage from "./pages/PaymentPage";
import UserDashboard from "./pages/panel/UserDashboard";
import FormulasPage from "./pages/panel/FormulasPage";
import FormulaDetailPage from "./pages/panel/FormulaDetailPage";
import DiseasesPage from "./pages/panel/DiseasesPage";
import DiseaseDetailPage from "./pages/panel/DiseasesDetailPage";
import AlcoholCalculator from "./pages/panel/AlcoholCalculator";
import MajistralSUT from "./pages/panel/MajistralSUT";
import AbbreviationPage from "./pages/panel/AbbreviationPage";
import DocumentsPage from "./pages/panel/DocumentsPage";

// Admin pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminFormulas from "./pages/admin/AdminFormulas";
import AddFormula from "./pages/admin/AddFormula";
import EditFormula from "./pages/admin/EditFormula";
import AdminDiseases from "./pages/admin/AdminDiseases";
import AddDisease from "./pages/admin/AddDisease";
import EditDisease from "./pages/admin/EditDisease";
import BlogListPage from "./pages/admin/BlogListPage";
import AddBlogPage from "./pages/admin/AddBlogPage";
import EditBlogPage from "./pages/admin/EditBlogPage";
import AdminMessages from "./pages/admin/AdminMessages";

function App() {
  return (
    <Router>
      <Routes>

        {/* --- PUBLIC --- */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/yasal-bilgiler" element={<LegalPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/blogs" element={<BlogListPublic />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />

        {/* --- PRIVATE (giriş yapan) --- */}
        <Route
          path="/profil"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/odeme"
          element={
            <PrivateRoute>
              <PaymentPage />
            </PrivateRoute>
          }
        />

        {/* --- ADMIN --- */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <AdminRoute>
              <AdminUsers />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/formulas"
          element={
            <AdminRoute>
              <AdminFormulas />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/formulas/add"
          element={
            <AdminRoute>
              <AddFormula />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/formulas/edit/:id"
          element={
            <AdminRoute>
              <EditFormula />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/diseases"
          element={
            <AdminRoute>
              <AdminDiseases />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/diseases/add"
          element={
            <AdminRoute>
              <AddDisease />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/diseases/edit/:id"
          element={
            <AdminRoute>
              <EditDisease />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/blogs"
          element={
            <AdminRoute>
              <BlogListPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/blogs/add"
          element={
            <AdminRoute>
              <AddBlogPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/blogs/edit/:id"
          element={
            <AdminRoute>
              <EditBlogPage />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contact-messages"
          element={
            <AdminRoute>
              <AdminMessages />
            </AdminRoute>
          }
        />

        {/* --- APPROVED USERS (Ödeme yapmış kullanıcı) --- */}
        <Route
          path="/panel"
          element={
            <ApprovedRoute>
              <UserDashboard />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/formulas"
          element={
            <ApprovedRoute>
              <FormulasPage />
            </ApprovedRoute>
          }
        />

        <Route
          path="/formul/:id"
          element={
            <ApprovedRoute>
              <FormulaDetailPage />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/diseases"
          element={
            <ApprovedRoute>
              <DiseasesPage />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/diseases/:id"
          element={
            <ApprovedRoute>
              <DiseaseDetailPage />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/alcohol"
          element={
            <ApprovedRoute>
              <AlcoholCalculator />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/sut"
          element={
            <ApprovedRoute>
              <MajistralSUT />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/teb"
          element={<Navigate to="https://tebapp.tebeczane.net/majistral" />}
        />

        <Route
          path="/panel/kisaltmalar"
          element={
            <ApprovedRoute>
              <AbbreviationPage />
            </ApprovedRoute>
          }
        />

        <Route
          path="/panel/dokumanlar"
          element={
            <ApprovedRoute>
              <DocumentsPage />
            </ApprovedRoute>
          }
        />

        {/* --- 404 --- */}
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </Router>
  );
}

export default App;